export const skusWithBluesign: string[] = [
  '00235-30181-10',
  '00235-50110-10',
  '00236-30088-10',
  '00236-40162-10',
  '00236-90216-10',
  '00236-90219-10',
  '00236-90220-10',
  '00236-90290-10',
  '00236-90291-10',
  '00236-90292-10',
  '00236-90293-10',
  '00251-30181-10',
  '00251-50110-10',
  '00253-30088-10',
  '00253-40162-10',
  '00253-90216-10',
  '00253-90219-10',
  '00253-90220-10',
  '00253-90290-10',
  '00253-90291-10',
  '00253-90293-10',
  '00253-90312-10',
  '00265-40162-10',
  '00265-90220-10',
  '00265-90290-10',
  '00265-90293-10',
  '00265-90312-10',
  '00268-30181-10',
  '00268-50110-10',
  '00272-30088-10',
  '00272-40162-10',
  '00272-90216-10',
  '00272-90219-10',
  '00272-90220-10',
  '00272-90290-10',
  '00272-90291-10',
  '00272-90292-10',
  '00272-90293-10',
  '00275-30181-10',
  '00275-50110-10',
  '00370-30072-10',
  '00885-40161-10',
  '00885-60086-10',
  '00894-10022-10',
  '00894-30072-10',
  '00894-30088-10',
  '00894-40162-10',
  '00894-50017-10',
  '00894-80001-10',
  '00894-900AG-10',
  '00894-900W6-10',
  '00894-90119-10',
  '00894-90120-10',
  '00894-90124-10',
  '00894-90136-10',
  '00894-90138-10',
  '00894-90183-10',
  '00894-90185-10',
  '00894-90186-10',
  '00894-90187-10',
  '00894-90216-10',
  '00894-90219-10',
  '00894-90220-10',
  '00894-90290-10',
  '00894-90291-10',
  '00894-90293-10',
  '00894-90312-10',
  '00895-20112-10',
  '00895-30085-10',
  '00895-30181-10',
  '00895-50110-10',
  '00895-80096-10',
  '00915-20112-10',
  '00915-30181-10',
  '00915-50110-10',
  '00919-20112-10',
  '00919-30181-10',
  '00919-50110-10',
  '00956-30088-10',
  '00956-90216-10',
  '00956-90219-10',
  '00956-90291-10',
  '01094-40161-10',
  '01094-60086-10',
  '01096-20170-10',
  '01096-30220-10',
  '01097-20166-10',
  '01099-40161-10',
  '01099-60086-10',
  '01100-20166-10',
  '01101-20170-10',
  '01101-30220-10',
  '01199-20112-10',
  '01199-30085-10',
  '01199-30181-10',
  '01199-50110-10',
  '01199-80096-10',
  '01200-20112-10',
  '01200-30085-10',
  '01200-30181-10',
  '01200-50110-10',
  '01200-80096-10',
  '01201-20112-10',
  '01201-30085-10',
  '01201-30181-10',
  '01201-50063-10',
  '01201-50110-10',
  '01201-80096-10',
  '01202-20112-10',
  '01202-30085-10',
  '01202-30181-10',
  '01202-50063-10',
  '01202-50110-10',
  '01202-80096-10',
  '01203-20112-10',
  '01203-30085-10',
  '01203-30181-10',
  '01203-50110-10',
  '01203-80096-10',
  '01205-20112-10',
  '01205-30085-10',
  '01205-30181-10',
  '01205-50110-10',
  '01205-80096-10',
  '01207-20112-10',
  '01207-30085-10',
  '01207-30181-10',
  '01207-50110-10',
  '01207-80096-10',
  'SAT-BSC-001-122',
  'SAT-BSC-001-211',
  'SAT-BSC-001-372',
  'SAT-BSC-001-385',
  'SAT-BSC-001-800',
  'SAT-BSC-001-820',
  'SAT-BSC-001-830',
  'SAT-BSC-001-9AG',
  'SAT-BSC-001-9BC',
  'SAT-BSC-001-9CD',
  'SAT-BSC-001-9DL',
  'SAT-BSC-001-9MA',
  'SAT-BSC-001-9MY',
  'SAT-BSC-001-9SB',
  'SAT-BSC-001-9SG',
  'SAT-BSC-001-9SP',
  'SAT-BSC-001-9TS',
  'SAT-BSC-001-9W6',
  'SAT-CRM-001-385',
  'SAT-CRM-001-563',
  'SAT-CRM-001-830',
  'SAT-CRO-001-385',
  'SAT-CRO-001-563',
  'SAT-CRO-001-830',
  'SAT-DUF-001-122',
  'SAT-DUF-001-211',
  'SAT-DUF-001-372',
  'SAT-DUF-001-385',
  'SAT-DUF-001-800',
  'SAT-DUF-001-820',
  'SAT-DUF-001-830',
  'SAT-DUF-001-9AG',
  'SAT-DUF-001-9BC',
  'SAT-DUF-001-9CD',
  'SAT-DUF-001-9DL',
  'SAT-DUF-001-9MY',
  'SAT-DUF-001-9NM',
  'SAT-DUF-001-9SB',
  'SAT-DUF-001-9SG',
  'SAT-DUF-001-9SP',
  'SAT-DUF-001-9TS',
  'SAT-DUF-001-9W6',
  'SAT-HAP-001-335',
  'SAT-HAP-001-410',
  'SAT-HAP-001-465',
  'SAT-HAP-001-480',
  'SAT-HAP-001-803',
  'SAT-RSD-001-DEU',
  'SAT-SPO-001-122',
  'SAT-SPO-001-211',
  'SAT-SPO-001-372',
  'SAT-SPO-001-385',
  'SAT-SPO-001-800',
  'SAT-SPO-001-820',
  'SAT-SPO-001-830',
  'SAT-SPO-001-9AG',
  'SAT-SPO-001-9BC',
  'SAT-SPO-001-9CD',
  'SAT-SPO-001-9DL',
  'SAT-SPO-001-9MY',
  'SAT-SPO-001-9NM',
  'SAT-SPO-001-9SB',
  'SAT-SPO-001-9SG',
  'SAT-SPO-001-9SP',
  'SAT-SPO-001-9TS',
  'SAT-SPO-001-9W6',
  'SAT-WAL-001-122',
  'SAT-WAL-001-211',
  'SAT-WAL-001-372',
  'SAT-WAL-001-385',
  'SAT-WAL-001-800',
  'SAT-WAL-001-820',
  'SAT-WAL-001-830',
  'SAT-WAL-001-9AG',
  'SAT-WAL-001-9BC',
  'SAT-WAL-001-9CD',
  'SAT-WAL-001-9DL',
  'SAT-WAL-001-9MY',
  'SAT-WAL-001-9SB',
  'SAT-WAL-001-9SG',
  'SAT-WAL-001-9SP',
  'SAT-WAL-001-9TS',
  'SAT-WAL-001-9W6',
]
